export interface Article {
  slug: string;
  title: string;
  description: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  content: string;
}

export const articles: Article[] = [
  {
    slug: '2024-zuixin-dianying-tuijian',
    title: '2024年最新热门电影推荐：不可错过的十部精选影片',
    description: '盘点2024年最值得期待和观看的热门电影，涵盖动作、科幻、剧情等多种类型，为您提供一站式观影导航指南。',
    category: 'yingshi',
    categoryName: '影视资源',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20cinematic%20movie%20theater%20interior%20with%20warm%20amber%20lighting%20and%20red%20velvet%20seats%2C%20elegant%20film%20reel%20projector%20in%20foreground%2C%20soft%20atmospheric%20glow%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20warm%20coral%20and%20gold%20tones&width=800&height=500&seq=article-movie-2024&orientation=landscape',
    publishDate: '2024-11-15',
    readTime: '8分钟',
    tags: ['电影推荐', '热门影片', '观影指南'],
    content: '<h3>2024年最值得观看的电影精选</h3><p>2024年是电影产业蓬勃发展的一年，众多优秀作品相继上映。我们为您精心挑选了十部不容错过的热门影片，涵盖多种类型，满足不同观众的口味。</p><h4>动作大片篇</h4><p>今年的动作片市场格外精彩，多部大制作影片带来了震撼的视觉体验。从好莱坞顶级制作到亚洲市场的新锐佳作，动作片爱好者今年可谓大饱眼福。</p><h4>剧情佳作篇</h4><p>剧情片方面，多部作品在各大电影节上获得了极高的评价。这些影片以深刻的主题和精湛的演技征服了观众和评论家。</p><h4>科幻奇幻篇</h4><p>科幻题材持续火热，几部备受期待的续集作品终于在今年与观众见面。视觉效果和故事深度都达到了新的高度。</p>',
  },
  {
    slug: 'remen-zongyi-jiemu-pan-dian',
    title: '2024年热门综艺节目大盘点：笑料与感动并存',
    description: '全面盘点今年最受欢迎的综艺节目，从真人秀到脱口秀，从音乐竞演到旅行综艺，为您推荐最值得一看的精彩内容。',
    category: 'zongyi',
    categoryName: '综艺娱乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20modern%20TV%20studio%20set%20with%20colorful%20stage%20lighting%20and%20warm%20spotlights%2C%20entertainment%20show%20production%20scene%2C%20professional%20broadcast%20equipment%2C%20vibrant%20atmosphere%20with%20warm%20golden%20and%20coral%20accents%2C%20editorial%20photography&width=800&height=500&seq=article-variety-2024&orientation=landscape',
    publishDate: '2024-11-10',
    readTime: '6分钟',
    tags: ['综艺节目', '真人秀', '娱乐推荐'],
    content: '<h3>年度综艺大盘点</h3><p>2024年的综艺市场百花齐放，各类节目争奇斗艳。从老牌综艺的持续创新到新生节目的异军突起，观众的选择越来越丰富。</p><h4>真人秀类</h4><p>真人秀依然是综艺市场的主力军。今年的真人秀节目更加注重真实感和情感共鸣，让观众在欢笑中感受温暖。</p><h4>音乐竞演类</h4><p>音乐类综艺继续保持着高热度，多档节目推出了全新的赛制和创意，为观众带来了耳目一新的视听体验。</p>',
  },
  {
    slug: 'guoman-xinfan-tuijian',
    title: '国漫崛起：2024年必追的国产动漫新番推荐',
    description: '国产动漫近年来质量不断提升，2024年又有多部精品国漫上线。本文为您盘点今年最值得追的国产动漫新番。',
    category: 'dongman',
    categoryName: '动漫番剧',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20illustration%20style%20scene%20with%20warm%20vibrant%20colors%2C%20Chinese%20animation%20aesthetic%20with%20traditional%20elements%20blended%20with%20modern%20design%2C%20soft%20golden%20and%20coral%20lighting%2C%20cinematic%20composition%2C%20high%20detail&width=800&height=500&seq=article-anime-2024&orientation=landscape',
    publishDate: '2024-11-08',
    readTime: '7分钟',
    tags: ['国漫', '新番推荐', '动漫'],
    content: '<h3>国漫崛起之年</h3><p>2024年，国产动漫继续保持着强劲的发展势头。越来越多的优秀作品涌现，在质量和数量上都达到了新的高度。</p><h4>仙侠题材</h4><p>仙侠类国漫依然是观众最喜爱的类型之一。今年的几部仙侠新作在画面表现和剧情深度上都有了显著提升。</p><h4>都市题材</h4><p>都市类国漫异军突起，以贴近生活的故事和细腻的情感刻画赢得了大量观众。</p>',
  },
  {
    slug: 'gaopinzi-jilupian-jingxuan',
    title: '高品质纪录片精选：开阔眼界的十部必看作品',
    description: '精选十部来自BBC、国家地理等顶级制作团队的高品质纪录片，涵盖自然、历史、科技等多个领域，带您探索世界的精彩。',
    category: 'jilupian',
    categoryName: '纪录片',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20photography%20scene%20with%20dramatic%20landscape%20and%20warm%20golden%20hour%20lighting%2C%20professional%20wildlife%20cinematography%20aesthetic%2C%20rich%20warm%20earth%20tones%20with%20amber%20highlights%2C%20epic%20scale%2C%20National%20Geographic%20style&width=800&height=500&seq=article-docu-2024&orientation=landscape',
    publishDate: '2024-11-05',
    readTime: '9分钟',
    tags: ['纪录片', 'BBC', '自然探索'],
    content: '<h3>纪录片：打开世界的窗口</h3><p>优秀的纪录片能够带我们穿越时空，探索未知的世界。本文为您精选了十部来自全球顶级制作团队的高品质纪录片。</p><h4>自然探索</h4><p>自然类纪录片一直是观众最喜爱的类型。精美的画面和深入的解说让人仿佛身临其境。</p><h4>历史文化</h4><p>历史类纪录片以严谨的态度和生动的叙事，带我们重温那些改变世界的重要时刻。</p>',
  },
  {
    slug: 'nba-xinsaiji-zhibo-zhinan',
    title: 'NBA新赛季观赛指南：热门球队与焦点赛事全解析',
    description: 'NBA新赛季火热进行中，本文为您详细解析本赛季各支热门球队的实力变化，以及不容错过的焦点赛事。',
    category: 'tiyu',
    categoryName: '体育赛事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20arena%20with%20dramatic%20stadium%20lighting%20and%20warm%20atmosphere%2C%20NBA%20game%20scene%20with%20players%20in%20action%2C%20energetic%20crowd%2C%20sports%20photography%20style%20with%20motion%20blur%2C%20warm%20golden%20and%20red%20tones&width=800&height=500&seq=article-nba-2024&orientation=landscape',
    publishDate: '2024-11-01',
    readTime: '7分钟',
    tags: ['NBA', '篮球', '赛事指南'],
    content: '<h3>NBA新赛季全面解析</h3><p>NBA新赛季已经拉开帷幕，各支球队经过休赛期的调整后焕然一新。本文带您全面了解本赛季的看点。</p><h4>争冠热门</h4><p>本赛季的争冠格局发生了不小的变化，几支传统强队和新晋劲旅将在赛场上展开激烈角逐。</p><h4>球星动态</h4><p>多位球星在新赛季迎来了新的挑战，他们的表现将直接影响球队的命运。</p>',
  },
  {
    slug: 'zaixian-xuexi-ziyuan-zhengli',
    title: '优质在线学习资源整理：从入门到精通的学习路径',
    description: '为您整理全网最优质的在线学习资源，涵盖编程、设计、语言等多个领域，帮助您高效规划学习路径，实现自我提升。',
    category: 'xuexi',
    categoryName: '学习教育',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20study%20space%20with%20laptop%20and%20books%20on%20wooden%20desk%2C%20warm%20natural%20light%20streaming%20through%20window%2C%20cozy%20learning%20environment%2C%20soft%20coral%20and%20warm%20beige%20color%20palette%2C%20editorial%20photography&width=800&height=500&seq=article-learn-2024&orientation=landscape',
    publishDate: '2024-10-28',
    readTime: '10分钟',
    tags: ['在线学习', '教育资源', '自我提升'],
    content: '<h3>高效学习的秘密</h3><p>在这个信息爆炸的时代，找到优质的学习资源是高效学习的第一步。本文为您整理了各领域的顶级在线学习资源。</p><h4>编程开发</h4><p>从零基础到高级开发者，编程学习资源的选择至关重要。我们精选了最受欢迎的编程学习平台和课程。</p><h4>设计创意</h4><p>设计领域的学习资源同样丰富，从平面设计到UI/UX设计，总有一款适合您。</p>',
  },
];

export const featuredArticles: Article[] = articles.slice(0, 3);